import {
  addCharter,
  getAirportsDetails,
  getAirlineDetails,
} from "app/services/charterService";
import axios from "axios";
import React, { Component, useState } from "react";
import Autosuggest from "react-autosuggest";

function AirportDeparture(props) {
  const [state, setState] = useState({
    value: "",
    suggestions: [],
  });

  // Filter logic
  const getSuggestions = async (value) => {
    // debugger;
    const inputValue = value.trim().toLowerCase();

    const { data } = await getAirportsDetails(value);
    const airportDetails = [];

    data.map((detail) =>
      airportDetails.push({
        id: detail.id,
        label: `${detail.cityName} ${detail.cityCode}`,
      })
    );
    return airportDetails;
  };

  const onSuggestionSelected = (id, suggestionValue) => {
    setState((prev) => ({ ...prev, value: suggestionValue.label }));
    props.setFieldValue(id, suggestionValue.id);
  };

  // Trigger suggestions
  const getSuggestionValue = (suggestion) => suggestion;

  // Render Each Option
  const renderSuggestion = (suggestion) => <div>{suggestion.label}</div>;

  // OnChange event handler
  const onChange = (event, { newValue }) => {
    setState((prev) => ({ ...prev, value: newValue }));
    props.setFieldValue(
      `flightLegs.onward[${props.index}].airportDepartureId`,
      ""
    );
  };

  // Suggestion rerender when user types
  const onSuggestionsFetchRequested = ({ value }) => {
    getSuggestions(value).then((data) => {
      if (data.Error) {
        setState((prev) => ({ ...prev, suggestions: [] }));
      } else {
        setState((prev) => ({ ...prev, suggestions: data }));
      }
    });
  };

  // Triggered on clear
  const onSuggestionsClearRequested = () => {
    setState((prev) => ({ ...prev, suggestions: [] }));
    //   props.setFieldValue(`flightLegs.onward[${  props.index}].airportDepartureId`, "");
  };

  const { value, suggestions } = state;

  // Option props
  const inputProps = {
    placeholder: "Airport Departure",
    value,
    onChange: onChange,
    className: "form-control",
    id: `flightLegs.onward[${props.index}].airportDepartureId`,
    name: `flightLegs.onward[${props.index}].airportDepartureId`,
  };

  // Adding AutoSuggest component
  return (
    <Autosuggest
      suggestions={suggestions}
      onSuggestionsFetchRequested={onSuggestionsFetchRequested}
      onSuggestionsClearRequested={onSuggestionsClearRequested}
      getSuggestionValue={getSuggestionValue}
      renderSuggestion={renderSuggestion}
      inputProps={inputProps}
      onSuggestionSelected={(event, { suggestionValue }) => {
        onSuggestionSelected(
          `flightLegs.onward[${props.index}].airportDepartureId`,
          suggestionValue
        );
      }}
    />
  );
}
export default AirportDeparture;
